export default "__VITE_ASSET__CdH_aG9I__"